export default __webpack_public_path__ + "static/living-in-stl-mobile-08f98fadd0ba08b0720566a1ae142f42.jpg";